import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from './constants';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const UPDATE_COLUMNS_RATIO = `${NAMESPACE}/UPDATE_COLUMNS_RATIO`;
export const VIDEO_PLAYER_MOUNTED = `${NAMESPACE}/VIDEO_PLAYER_MOUNTED`;
export const UPDATE_COMMANDS_FILTER = `${NAMESPACE}/UPDATE_COMMANDS_FILTER`;
export const APPEND_NOTIFICATION = `${NAMESPACE}/APPEND_NOTIFICATION`;
export const SET_GALLERY_FULL_SCREEN = `${NAMESPACE}/SET_GALLERY_FULL_SCREEN`;
export const SET_OPEN_SAUCE_USER = `${NAMESPACE}/SET_OPEN_SAUCE_USER`;
export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const UPDATE_LOGS_VIEWER_STATE = `${NAMESPACE}/UPDATE_LOGS_VIEWER_STATE`;

export const INITIALIZE = createApiNamespacedConstants('INITIALIZE');
